export default __webpack_public_path__ + "static/media/wm2.611616b5.jpg";